/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const o = 'is-open';
	const h = 'is-hidden';
	const v = 'is-visible';
	const breakpoint = 768;

	// PICK UP箇所スライダー
	const slider02 = () => {
		$('.product-slider').slick({
			arrows: true,
			prevArrow: '<a class="slick-prev" href="#"><img src="/common/images/arrow_left_grd.svg" class=""></a>',
			nextArrow: '<a class="slick-next" href="#"><img src="/common/images/arrow_right_grd.svg" class=""></a>',
			autoplay: true,
			adaptiveHeight: true,
			centerMode: true,
			centerPadding: "20%",
			dots: false,
		    responsive: [
		    	{
					arrows: false,
		    		breakpoint: 768,
		    		settings: {
		    			slidesToShow: 1,
		    			centerMode: false,
		    		},
		    	},
		    ],
	   });
	   $('.product-slider p').matchHeight();
	}
	// ＜検索フォーム＞検索フォーム部分開閉
	const searchFormSwitch = () => {
		$('.product-search__detailSearch .__switch').on('click', (e) => {
			e.preventDefault();
			$(e.currentTarget).toggleClass(o);
			$('.product-search__detailSearch .__body').slideToggle(400);
		});
		$('.product-search__detailSearch .__classificationSwitch').on('click', (e) => {
			e.preventDefault();
			$(e.currentTarget).toggleClass(o);
			$('._classification').slideToggle(400);
		});
		$('.product-search__detailSearch .__keywordSwitch').on('click', (e) => {
			e.preventDefault();
			$(e.currentTarget).toggleClass(o);
			$('._keyword').slideToggle(400);
		});
	};
	// ＜検索フォーム＞リセットボタン処理
	const searchFormReset = () => {
		$('.js-searchReset').on('click', () => {
			$('.product-searchBlock').find('select').each((idx, val) => {
				$(val).val('');
			});
			$('.product-searchBlock').find('input[type="text"]').each((idx, val) => {
				$(val).val('');
			});
			$('.product-searchBlock').find('input[type="checkbox"]').each((idx, val) => {
				$(val).prop('checked', false);
			});
			if (location.pathname.replace('index.html','') == '/product/'){
				// $('html, body').animate({ scrollTop: 0 }, '400', 'swing');
			} else {
				// $('form').submit();
			}
		});
	};

	const productSearchConditions = () => {

		// keyword検索　pulldown描画
		if($('.js-pulldown-business').length) {
			const businessPulldown = $('.js-pulldown-business');
			let lang = '';
			if(location.pathname.split('/')[1] === 'english') {
				lang = '/english';
			}
			const getJSONproductSearchConditions = (_lang) => {
				return $.getJSON(`/ajax${_lang}/product/business.json`);
			};
			// パラメータ格納関数
			const pArray = () => {
				let urlParam = location.search.substring(1);
				let paramArray = [];
				if(urlParam) {
					let param = urlParam.split('&');
					for(let i = 0; i < param.length; i++) {
						let paramItem = param[i].split('=');
						paramArray[paramItem[0]] = paramItem[1];
					}
				}
				return paramArray;
			};

			getJSONproductSearchConditions(lang).then((data) => {
				// console.log(data,'getJSONproductSearchConditions');
				for(let i=0; i < data.rt_bn_product_tag_business.length; i++) {
					// console.log(data,'data');
					let categoryName = data.rt_bn_product_tag_business[i].cf_pt_name_d;
					if(location.pathname.split('/')[1] === 'english') {
						categoryName = data.rt_bn_product_tag_business[i].cf_pt_name_d_en;
					}
					if(!(pArray()['p_tag_business'] === data.rt_bn_product_tag_business[i]._key)) {
						businessPulldown.append($('<option>').html(''+categoryName+'').val(data.rt_bn_product_tag_business[i]._key));
					} else {
						businessPulldown.append($('<option>').html(''+categoryName+'').val(data.rt_bn_product_tag_business[i]._key).prop('selected', true));
						for (let l = 0; l < $('.js-product-keyword-tag').length; l++) { //タグの数のループ
							if($('.js-product-keyword-tag').eq(l).find('p').data('code') === data.rt_bn_product_tag_business[i]._key) {
								$('.js-product-keyword-tag').eq(l).removeClass('di_none');
							}
						}
					}
				}
			});
		}

		// keyword tag描画
		if($('.js-product-keyword-tag').length) {
			// console.log($('.js-product-keyword input[type="checkbox"]:checked').length,'チェックされているinput数');
			for (let l = 0; l < $('.js-product-keyword-tag').length; l++) { //タグの数のループ
				// console.log($('.js-product-keyword-tag').length,'tag数');
				// console.log($('.js-product-keyword-tag').eq(l).find('p').data('code'),'tag要素');
				for (let i = 0; i < $('.js-product-keyword input[type="checkbox"]:checked').length; i++) {　//チェックされているチェックボックスのループ
					// console.log($('.js-product-keyword input[type="checkbox"]:checked').eq(i).val(),'チェックされているinput要素');

					//tag要素とチェックされているinput要素が同じなら
					if($('.js-product-keyword-tag').eq(l).find('p').data('code') === $('.js-product-keyword input[type="checkbox"]:checked').eq(i).val()) {

						//di_noneをつける
						$('.js-product-keyword-tag').eq(l).removeClass('di_none');
					}
				}
			}
		}
	
	};

   slider02();
   searchFormSwitch();
   searchFormReset();
   productSearchConditions();

})(window.jQuery, window.FUNCTIONS);
